<template>
  <div id="contact">
    <!-- <div class="page-header section-image"  data-parallax="true" style="background-image: url('/static/img/聯絡我們.jpg'); height:60vh"> -->
    <div class="page-header header-filter"  data-parallax="true" style="background-image: url('/static/img/contact.jpg'); height:50vh; background-position:0px 44%">
      <div class="container">
        <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <div class="brand text-center">
                  <h1 class="title" id="hide_edit" @click="edit_contact">聯絡我們</h1>
                  <h3 class="title description">Contact us</h3>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div class="main main-raised">
        <div class="container">
          <div class="section">
            <div class="alert alert-success" role="alert" id="msgBox" style="display:none">
              {{ alertMag }}
            </div>
            <div class="row">
              <div class="col-md-5">
                <div class="info info-horizontal" style="padding:0px 0px 0px">
                  <div class="icon icon-primary">
                    <i class="material-icons">phone_iphone</i>
                  </div>
                  <div class="description">
                    <h4 class="info-title">Social Media</h4>
                    <div class="row">
                      <template v-for="(item, index) in media">
                        <div class="col" :key="index">
                          <img style="width:100%" :src="item.img">
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- <div class="info info-horizontal" style="padding:0px 0px 0px">
                  <div class="icon icon-primary">
                    <i class="material-icons">pin_drop</i>
                  </div>
                  <div class="description">
                    <h4 class="info-title">Address</h4>
                    <p>
                      {{ cht_addr }}
                      <span style="white-space:pre">
                        {{ eng_addr }}
                      </span>
                    </p>
                  </div>
                </div> -->
                <div class="info info-horizontal" style="padding:30px 0px 0px">
                  <div class="icon icon-primary">
                    <i class="material-icons">phone</i>
                  </div>
                  <div class="description">
                    <h4 class="info-title">Give us a ring</h4>
                    <p>
                      {{ cont_peo }}
                      <br> {{ tele }}
                      <br> {{ work_day }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-5 ml-auto">
                <div class="card card-contact">
                  <div id="contact-form">
                    <div class="card-header card-header-raised card-header-primary text-center">
                      <h4 class="card-title">Contact Us</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md">
                          <div class="form-group label-floating is-e mpty">
                            <label class="bmd-label-floating">姓名 Name</label>
                            <input type="text" name="name" class="form-control" v-model="name">
                            <span class="material-input"></span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group label-floating is-empty">
                        <label class="bmd-label-floating">信箱 Email address</label>
                        <input type="email" name="email" class="form-control" v-model="address">
                        <span class="material-input"></span>
                      </div>
                      <div class="form-group label-floating is-empty">
                        <label for="exampleMessage1" class="bmd-label-floating">訊息 Your Message</label>
                        <textarea name="message" class="form-control" id="exampleMessage1" rows="6" v-model="msg"></textarea>
                        <span class="material-input"></span>
                      </div>
                    </div>
                    <div class="card-footer justify-content-between">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" v-model="robot_check"> I'm not a robot
                          <span class="form-check-sign">
                            <span class="check"></span>
                          </span>
                        </label>
                      </div>
                      <button v-if="robot_check" class="btn btn-primary pull-right" @click="sent">Send Message</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "contact",
  props: [],
  data() {
    return {
      cht_addr: '',
      eng_addr: '',
      cont_peo: '',
      tele: '',
      work_day: '',
      media: [],
      name: '',     // 寄信
      address: '',
      msg: '',
      robot_check: false,
      alertMag:''
    };
  },
  methods: {
    getData: function(){
      var vm = this;
       axios
          .get(`/api/getcontact`)
          .then(res => {
            // console.log(res.data);
            var data = res.data.data[0];

            vm.cht_addr = data.cht_addr;
            vm.eng_addr = data.eng_addr;

            vm.cont_peo = data.cont_peo;
            vm.tele = data.tele;
            vm.work_day = data.work_day;

            var img = data.img;
            if(img != null && img != '' && img != 'null'){
              var img_arr = img.split('@');
              var img_len = img.split('@').length;
              if(img_len > 1){
                for(var j = 0; j < img_len; j++){
                  vm.media.push({
                    img: img_arr[j]
                  })
                }
              }
              else{
                vm.media.push({
                  img: img
                })
              }
            }

          })
          .catch(err => {
            console.log(err);
          });
    },
    sent: function(){
      var vm = this;
      if(vm.name != "" && vm.address != "" && vm.msg != ""){
        axios
        .post(`/api/email`,{
          name: vm.name,
          address: vm.address,
          msg: vm.msg
        })
        .then(res => {
          // console.log(res);
          if(res.status == 200){
            vm.showMag('傳送成功 !');
            
            vm.name = '';
            vm.address = '';
            vm.msg = '';
            vm.robot_check = false;
          }
              
        })
        .catch(err => {
          console.log(err);
        });
      }
      else{
        vm.showMag('請輸入完整 !');
      }
      
    },
    edit_contact: function() {
      var vm = this;
      document
        .querySelector("#hide_edit")
        .addEventListener("click", function(evt) {
          // console.log(evt.detail)

          if (evt.detail === 3) {
            vm.$router.push("/edit_contact").catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }
        });
    },
    showMag: function(alertMag){

      this.alertMag = alertMag;

      $("#msgBox").show(1000);
      setTimeout(function(){ $("#msgBox").hide(1000); }, 3000);
    }
  },
  filters: {},
  computed: {},
  created() {
    this.getData();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/contact/contact.vue